import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import { Translate as $t } from "@/plugins/translate";
import OocOrder from "@/modules/ooc/order";
import OocOrderInterface from "@/interface/app/ooc/order.interface";
export default {
  namespaced: true,
  state: {
    success: false,
    message: null,
    count: 0,
    orders: [],
    ordersList: [],
    order: null,
  },
  getters: {
    count: (state: any): Number => state.count,
    order: (state: any): OocOrderInterface => state.order,
    orders: (state: any): OocOrderInterface => state.orders,
    ordersList: (state: any): Array<any> => state.ordersList,
    ResponseStatus: (state: any): any => ({
      success: state.success,
      message: state.message,
    }),
  },
  mutations: {
    SET_RESPONSE_STATUS(state: any, payload: any) {
      state.message = payload?.message || null;
      state.success = payload?.success || false;
    },

    SET_ORDERS_LIST(state: any, payload: any) {
      state.orders = payload?.orders;
      state.count = payload?.meta?.total_records || 0;
    },
    SET_ORDER(state: any, payload: any = null) {
      state.order = new OocOrder(payload);
    },
  },
  actions: {
    async getOrders(
      { commit }: { commit: any },
      { page = 1, itemsPerPage = 15, search = null, statuses = "", startDate, endDate }
    ) {
      let statusSearch = statuses ? `&status=${statuses}` : "";
      let timeStart = startDate ? `&start_date=${startDate}` : "";
      let timeEnd = endDate ? `&end_date=${endDate}` : "";
      return await request
        .get(
          `${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.ORDERS}?page=${page}&page_size=${itemsPerPage}&name=${search}${statusSearch}${timeStart}${timeEnd}`
        )
        .then((response) => response.data)
        .then(async ({ data, meta }) => {
          // summarization list
          const orders = data.map((order) => new OocOrder(order));
          // commit list
          await commit("SET_ORDERS_LIST", { orders, meta });
          await commit("SET_RESPONSE_STATUS", { success: true, message: data?.message });
        })
        .catch(async ({ error }) => {
          await commit("SET_ORDERS_LIST", { orders: null, count: 0 });
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });
          console.log(error);
        });
    },
    /**
     * get single order
     * @param commit
     * @param orderId
     */
    async getOrder({ commit }: { commit: any }, { orderId }) {
      return await request
        .get(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.ORDER(orderId)}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_ORDER", data);
        })
        .catch(async (error) => {
          console.log(error);
          await commit("SET_ORDER", null);
        });
    },
    /**
     * will resend order
     * @param commit
     * @param orderId
     */
    async resendOrder({ commit }: { commit: any }, { orderId }) {
      return await request
        .post(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.RESEND_ORDER(orderId)}`)
        .then((response) => response.data)
        .then(async ({ data }) => await commit("SET_RESPONSE_STATUS", { success: true, message: data?.message }))
        .catch(async (error) => {
          console.log(error);
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });
        });
    },
  },
};
